import { ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { RootScopeService } from '../../../services/root-scope.service';
import * as Constants from './../../../models/Constants';
import { Tab } from 'src/app/models/tab.model';
import _ from 'lodash';
declare var $: any;

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
  host: { '(window:keydown)': 'browserEvent($event)' },
})
export class CustomDialogComponent implements OnInit {
  @Input() additionalClass: any;
  @Output() actionOnClick = new EventEmitter();

  constructor(public rootScope: RootScopeService) { }

  ngOnInit(): void { }

  buttonClicked(buttonLabel) {

    let data = {
      type: this.rootScope.customDialogData.type,
      buttonType: buttonLabel,
      msg: this.rootScope.customDialogData.msg
    };
    this.actionOnClick.emit(data);
    if (this.rootScope.customDialogData.displayCustomDialog)
      this.rootScope.customDialogData.displayCustomDialog = false;
    if (this.rootScope.customDialogData.displayCustomDialogCS)
      this.rootScope.customDialogData.displayCustomDialogCS = false;
    if (this.rootScope.customDialogData.displayCustomDialogCA)
      this.rootScope.customDialogData.displayCustomDialogCA = false;

    if (this.rootScope.customDialogData?.customClass == 'inbound-modal' &&
      this.rootScope.customDialogData?.buttonLabel2 == Constants.GOT_IT_BUTTON_TYPE) {
      this.rootScope.customDialogData.customClass = '';
      this.routeBackActiveTab();
    }
  }

  browserEvent(event) {
    if (event.keyCode == ENTER) this.buttonClicked(event.target.innerText);
  }
/**
 * route to previous selected tab 
 */
  /**
   * Navigates back to the active customer tab if a valid customer session ID exists.
   * 
   * This method checks if the `activeCustTab` has a `customerSessionId`. If it exists,
   * it assigns the ID to `customerLink` and navigates to the corresponding customer account
   * page using Angular's router. The navigation is performed with `skipLocationChange` set
   * to `true`, ensuring the browser's URL does not update in the address bar.
   * 
   * @remarks
   * If no valid `customerSessionId` is found, the method does nothing.
   * / @author Vamsi.pamidala
   * CCR3-11668
   */
  routeBackActiveTab() {
    this.rootScope.customerLink =
      this.rootScope.activeCustTab?.customerSessionId ? this.rootScope.activeCustTab.customerSessionId : 0;
    if (!this.rootScope.checkLiveChatAccount()) {
      this.rootScope.isLiveChat = false;
      this.rootScope.isLiveCall=false;
   
    _.filter(this.rootScope.customerTabs, {
          active: false,
          activeChat: false,
          activeCall: false,
        }).forEach((element) => {
          element.active = true;          
        });
    }
    if (this.rootScope.customerLink == 0 && this.rootScope.activeChatOrCall()) {
      this.rootScope.customerLink = this.rootScope.customerTabs?.[this.rootScope.customerTabs.length - 1]?.customerSessionId || 0;
      this.rootScope.activeCustTab = this.rootScope.getObjFromArray(
        this.rootScope.customerTabs,
        'customerSessionId',
        this.rootScope.customerLink
      );
    }
    
    if (this.rootScope.customerLink != 0) {
      this.rootScope.router.navigate(
        [`/customer-account/${this.rootScope.customerLink}`],
        {
          skipLocationChange: true,
        }
      );
    }
  }
}
